import { Button, Divider, Form, Input, InputRef, Select, Space } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useHistory, useParams } from 'react-router-dom';
import { MinEditIcon, UploadBigIcon, UploadMinIcon } from '../../../assets/images/blogForm';
import noProfilePicture from '../../../assets/images/blogForm/noProfilePicture.png';
import ChargerModule from '../../../components/chargerModule';
import { CKEditor } from 'ckeditor4-react';
import { v4 as uuid } from 'uuid';
import { useEffect, useRef, useState } from 'react';
import FloatButtons from '../../../components/floatButtons';
import EditIcon from '../../../assets/images/catalogue/EditIcon';
import ArrowIcon from '../../../assets/images/blogForm/arrowIcon';
import {
  addBlog,
  addCategory,
  getCategories,
  getUserDetail,
  blogDetail,
  editBlog,
  updatePhoto
} from '../../../services/blog';
import errorMessage from '../../../utils/errorMessage';
import { IBlogCategories, IInfoEditBlog, IUserDetail, TAny } from '../../../types/blog';
import './BlogForm.scss';
import { getNudosData } from '../../../utils/getNudosData';
import { HidenUpload } from '../../../components/hidenUpload';
import { validateImg } from '../../../utils/validateFiles';
import { LoadingOutlined } from '@ant-design/icons';
import alertMessage from '../../../utils/alertMessage';
import LoaderProfile from './loaderProfileInfo';
import FullLoader from './FullLoader';
import { formatShortDate } from '../../../utils/formatDatesAndHours';

interface IParams {
  blogId: string;
}
const BlogForm = () => {
  const infoSideBar = { position: 'blog' };
  const headerInfo = { title: 'Blog', titleRoute: '/blog/list', subtitle: 'Nueva entrada' };
  const [dataHtml, setDataHtml] = useState<string>('');
  const [categoriesData, setCategoriesData] = useState<IBlogCategories[]>();
  const [userInfoData, setUserInfoData] = useState<IUserDetail>();
  const [temporalThumb, setTemporalThumb] = useState<string>();
  const [temporalImg, setTemporalImg] = useState<string>();
  const [thumbFile, setThumbFile] = useState<TAny>();
  const [imgFile, setImgFile] = useState<TAny>();
  const [loadingSaveBlog, setLoadingSaveBlog] = useState<boolean>(false);
  const [loadingNewCategory, setloadingNewCategory] = useState<boolean>(true);
  const [dataBlog, setDataBlog] = useState<IInfoEditBlog>();
  const [loadingBlog, setLoadingBlog] = useState<boolean>(false);
  const [loadingUserInfo, setLoadingUserInfo] = useState<boolean>(false);

  const { push } = useHistory();
  const nudosData = getNudosData();
  const { blogId }: IParams = useParams();
  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const [editForm, setEditForm] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [imgProfileTemporal, setImgProfileTemporal] = useState<string>();
  const category = Form.useWatch('category', form);
  const title = Form.useWatch('title', form);
  const shortDescription = Form.useWatch('shortDescription', form);
  const [isDate, setIsDate] = useState<string>('');
  const { Option } = Select;

  const onEditorChange = (evt: any) => {
    const htmlString = evt.editor.getData();
    setEditForm(true);
    setDataHtml(htmlString);
  };

  const getDataCategories = async () => {
    try {
      const dataCategories = await getCategories();
      setCategoriesData(dataCategories);
      setName('');
      setloadingNewCategory(false);
    } catch (error) {
      setloadingNewCategory(false);
      errorMessage();
    }
  };

  const getDataInfoUser = async () => {
    setLoadingUserInfo(true);
    try {
      const dataUser = await getUserDetail(nudosData?.userData?.id || 0);
      setUserInfoData(dataUser);
      setLoadingUserInfo(false);
    } catch (error) {
      setLoadingUserInfo(false);
      errorMessage();
    }
  };
  const thumbChange = (file: TAny) => {
    const dataThumb = validateImg(file, true);
    if (dataThumb) {
      setEditForm(true);
      setTemporalThumb(dataThumb.temporalUrl);
      setThumbFile(dataThumb.file);
    }
  };
  const imgChange = (file: TAny) => {
    const dataImg = validateImg(file, true);
    if (dataImg) {
      setEditForm(true);
      setTemporalImg(dataImg.temporalUrl);
      setImgFile(dataImg.file);
    }
  };
  const sendForm = async (endData: TAny) => {
    setLoadingSaveBlog(true);
    var formData = new FormData();
    imgFile && formData.append('image', imgFile, `pricipal_img_${uuid()}`);
    thumbFile && formData.append('thumbnail', thumbFile, `thumb_img_${uuid()}`);
    if (blogId) {
      formData.append(
        'post',
        JSON.stringify({
          categoryId: endData?.category,
          title: endData.title,
          shortDescription: endData.shortDescription,
          body: dataHtml,
          thumbnailUrl: temporalThumb,
          imageUrl: temporalImg,
          authorRole: endData?.authorRole,
          authorPhotoUrl: userInfoData?.photoProfile
        })
      );
      try {
        await editBlog(nudosData?.userData?.id || 0, blogId, formData);
        alertMessage('Se han guardado los cambios');
        push('/blog/list');
        setLoadingSaveBlog(false);
      } catch (error: TAny) {
        errorMessage(error?.response?.data?.message);
        setLoadingSaveBlog(false);
      }
    } else {
      formData.append(
        'post',
        JSON.stringify({
          userId: nudosData?.userData?.id,
          authorName: `${userInfoData?.firstName || ''} ${userInfoData?.lastName || ''}`,
          authorRole: endData?.authorRole,
          authorPhotoUrl: userInfoData?.photoProfile,
          categoryId: endData?.category,
          title: endData.title,
          shortDescription: endData.shortDescription,
          body: dataHtml
        })
      );
      try {
        await addBlog(formData);
        alertMessage('La publicación se ha creado correctamente');
        push('/blog/list');
        setLoadingSaveBlog(false);
      } catch (error) {
        errorMessage();
        setLoadingSaveBlog(false);
      }
    }
  };

  const addNewCategory = async () => {
    setloadingNewCategory(true);
    try {
      await addCategory(name);
      getDataCategories();
    } catch (error) {
      setloadingNewCategory(false);
      errorMessage();
    }
  };

  const getDataBlog = async () => {
    setLoadingBlog(true);
    try {
      const dataBlogDetail = await blogDetail(blogId);
      setDataBlog(dataBlogDetail);
      setTemporalThumb(dataBlogDetail?.thumbImage || '');
      setTemporalImg(dataBlogDetail?.image || '');
      setDataHtml(dataBlogDetail?.postBody || '');
      setLoadingBlog(false);
    } catch (error) {
      setLoadingBlog(false);
      errorMessage();
    }
  };

  const disabledButton = () => {
    if (blogId) {
      if (dataHtml && temporalImg && temporalThumb && title && category && shortDescription && editForm) {
        return false;
      } else {
        return true;
      }
    } else {
      if (dataHtml && temporalImg && temporalThumb && title && category && shortDescription) {
        return false;
      } else {
        return true;
      }
    }
  };

  const updateProfilePicture = async (file: TAny) => {
    const validateFile = validateImg(file, true);
    if (validateFile) {
      setLoadingUserInfo(true);
      try {
        const formData = new FormData();
        formData.append('file', validateFile.file, `profile_picture_${uuid()}`);
        const dataPhoto: TAny = await updatePhoto(nudosData?.userData?.id || 0, formData);
        if (blogId) {
          const formData = new FormData();
          formData.append('post', JSON.stringify({ authorPhotoUrl: dataPhoto.url }));
          await editBlog(nudosData?.userData?.id || 0, blogId, formData);
          await getDataInfoUser();
          setImgProfileTemporal(dataPhoto.url);
          setLoadingUserInfo(false);
        } else {
          await getDataInfoUser();
          setLoadingUserInfo(false);
        }
      } catch (error) {
        setLoadingUserInfo(false);
        errorMessage();
      }
    }
  };

  const generateDate = () => {
    if (dataBlog) {
      const isDate = formatShortDate(dataBlog?.createdAt || '')?.textWithTimezone;
      setIsDate(isDate || '');
    } else {
      var today = new Date();
      setIsDate(today.toLocaleDateString('en-US'));
    }
  };

  const spacesImg = (url: string | undefined) => {
    if (url) {
      return url.replaceAll(' ', '%20');
    }
    return '';
  };
  useEffect(() => {
    getDataInfoUser();
    getDataCategories();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (blogId) {
      getDataBlog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogId]);

  useEffect(() => {
    generateDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataBlog]);
  return (
    <ChargerModule infoSideBar={infoSideBar} headerInfo={headerInfo}>
      <div id="blogForm">
        {loadingBlog ? (
          <FullLoader />
        ) : (
          <Form
            className="w-full h-full"
            name="blog_form"
            form={form}
            onFinish={sendForm}
            onFieldsChange={() => {
              setEditForm(true);
            }}
          >
            <div className="boxBlogs">
              <div className="containerHeader">
                <div className="backContainer">
                  <div
                    className="arrowContainer"
                    onClick={() => {
                      push('/blog/list');
                    }}
                  >
                    <ArrowIcon />
                  </div>
                  <div
                    className="textBack"
                    onClick={() => {
                      push('/blog/list');
                    }}
                  >
                    Listado
                  </div>
                </div>
                <div className="containerTitleBlog">
                  <div className="titleBlog">{blogId ? `Publicación #${blogId}` : 'Nueva publicación'}</div>
                  <div className="floatDate">
                    <div className="textDate">
                      <strong> Fecha de publicación</strong> <br /> {isDate}
                    </div>
                  </div>
                </div>
              </div>
              <div className="containerAllForms">
                <div className="firstForm">
                  <div className="firstSection">
                    <div className="spaceSection">
                      <div className="mediumItems mr-5">
                        <div className="labelItem">Categoría</div>
                        <div className="boxItem">
                          <Form.Item>
                            <Form.Item
                              initialValue={dataBlog?.categoryId}
                              noStyle
                              name="category"
                              rules={[{ required: true, message: 'campo requerido' }]}
                            >
                              <Select
                                className="customSelect"
                                placeholder="Novedades en Nudos"
                                dropdownRender={menu => (
                                  <>
                                    {menu}
                                    <Divider style={{ margin: '8px 0' }} />
                                    <Space style={{ padding: '0 8px 4px' }}>
                                      <Input
                                        placeholder="Categoría"
                                        ref={inputRef}
                                        value={name}
                                        onChange={e => {
                                          setName(e.target.value);
                                        }}
                                      />
                                      <Button
                                        style={{
                                          fontSize: '12px',
                                          color: name ? '#070F21' : '#999999',
                                          background: 'white',
                                          width: '170px'
                                        }}
                                        type="text"
                                        onClick={() => {
                                          if (!loadingNewCategory && name) {
                                            addNewCategory();
                                          }
                                        }}
                                      >
                                        {loadingNewCategory ? (
                                          <LoadingOutlined style={{ fontSize: '20px' }} />
                                        ) : (
                                          'Agregar nueva categoría'
                                        )}
                                      </Button>
                                    </Space>
                                  </>
                                )}
                              >
                                {categoriesData &&
                                  categoriesData.length > 0 &&
                                  categoriesData.map(item => {
                                    return (
                                      <Option key={uuid()} value={item.id}>
                                        <div className="text-xs leading-3 mt-2">{item.name}</div>
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="mediumItems">
                        <div className="labelItem">Título de la publicación</div>
                        <div className="boxItem">
                          <Form.Item
                            noStyle
                            name="title"
                            rules={[{ required: true, message: 'campo requerido' }]}
                            initialValue={dataBlog?.postTitle}
                          >
                            <Input className="customInput" placeholder="Conoce Nodi" />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="spaceSection mt-2">
                      <div className="spaceTextArea">
                        <div className="labelItem">Descripción corta</div>
                        <div className="boxTextArea">
                          <Form.Item noStyle name="shortDescription" initialValue={dataBlog?.shortDescription}>
                            <TextArea
                              maxLength={110}
                              className="customTextArea"
                              placeholder="Conoce cómo equipar a tus empleados"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    {loadingUserInfo ? (
                      <LoaderProfile />
                    ) : (
                      <div className="spaceSection mt-5">
                        <div className="boxProfile">
                          <div className="containerImg">
                            <HidenUpload
                              handleChangeFile={e => {
                                updateProfilePicture(e);
                              }}
                            />
                            <MinEditIcon className="floatIcon" />
                            <div
                              className="profilePicture"
                              style={{
                                backgroundImage: `url(${
                                  imgProfileTemporal ||
                                  spacesImg(dataBlog?.authorImage) ||
                                  spacesImg(userInfoData?.photoProfile) ||
                                  noProfilePicture
                                })`
                              }}
                            />
                          </div>
                          <div className="containerInfo">
                            <div>
                              <div className="titleImg">Imagen de quién publica</div>
                              <div className="subTitleImg">{'(32x32px)'}</div>
                            </div>
                          </div>
                        </div>
                        <div className="minItems mr-5">
                          <div className="labelItem">Nombre de quien publica</div>
                          <div className="boxItem">
                            <Input
                              className="customInput"
                              value={`${
                                dataBlog
                                  ? `${dataBlog?.authorName}`
                                  : `${userInfoData?.firstName || ''} ${userInfoData?.lastName || ''}`
                              }`}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="minItems">
                          <div className="labelItem">Cargo</div>
                          <div className="boxItem">
                            <Form.Item
                              noStyle
                              name="authorRole"
                              initialValue={dataBlog?.authorRole || userInfoData?.role}
                            >
                              <Input className="customInput" placeholder="Cofounder" />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="secondSection">
                    <div className="boxUploadImg">
                      <div className="firstImgBox">
                        <div className="containerImg">
                          <div className="noImg">
                            <HidenUpload
                              handleChangeFile={file => {
                                thumbChange(file);
                              }}
                            />
                            {temporalThumb ? (
                              <img alt="temporalImg" className="sizeImgForm" src={temporalThumb} />
                            ) : (
                              <UploadMinIcon />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="titleFirsImg">
                        Imagen de thumbnail<span className="text-nudos-gray-400"> (280x140px)</span>
                      </div>
                      <div className="boxLine">
                        <div className="grayLine"></div>
                      </div>
                      <div className="secondImgBox">
                        <div className="containerImg">
                          <div className="noImg">
                            <HidenUpload
                              handleChangeFile={file => {
                                imgChange(file);
                              }}
                            />
                            {temporalImg ? (
                              <img alt="temporalImg" className="sizeImgForm" src={temporalImg} />
                            ) : (
                              <UploadBigIcon />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="titleFirsImg">
                        Imagen principal<span className="text-nudos-gray-400"> (580x200px)</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="secondForm">
                  <div className="titleSecond">Cuerpo</div>
                  <div className="containerHtmlElement">
                    <CKEditor
                      initData={dataHtml}
                      onChange={onEditorChange}
                      config={{ width: '100%', height: 326, resize_enabled: false }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <FloatButtons>
              <Form.Item className="positionButton" shouldUpdate>
                {() => (
                  <Button
                    className="grayButton"
                    type="primary"
                    htmlType="submit"
                    disabled={loadingSaveBlog || disabledButton()}
                  >
                    {loadingSaveBlog ? (
                      <LoadingOutlined style={{ fontSize: '20px' }} />
                    ) : (
                      <>
                        <div className="litleButton">
                          <EditIcon
                            stroke={disabledButton() || loadingSaveBlog ? '#B3B3B3' : ''}
                            fill={disabledButton() || loadingSaveBlog ? '#ececec' : ''}
                            className="positionIcon"
                          />
                        </div>
                        Guardar
                      </>
                    )}
                  </Button>
                )}
              </Form.Item>
            </FloatButtons>
          </Form>
        )}
      </div>
    </ChargerModule>
  );
};

export default BlogForm;
